export default __webpack_public_path__ + "static/media/app_logo_manoa.01f34c83.png";